var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgSugar = function SvgSugar(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.855 1.65h5.495v4.995l-.005.005h3.005v4.973l-2.182 2.727H7.65v-1.505L6.145 14.35H.65V9.355L3.355 6.65H4.65V3.855L6.855 1.65ZM4.65 7.35H3.645l-1.8 1.8h4.01l.3-.3H4.65v-1.5Zm2.495 1.5-.795.795v3.51l1.3-1.3v-2.5l.505-.505h-1.01Zm3 0 1.5-1.5h2.627l-1.44 1.8H8.845l.3-.3h1Zm-3-6.5-1.3 1.3h4.01l1.3-1.3h-4.01Zm4.505.495-1.3 1.3v3.51l1.3-1.3v-3.51Zm-2 5.305v-3.8h-4.3v3.8h4.3Zm5-.152-1.3 1.625v3.38l1.3-1.626v-3.38Zm-2 5.652v-3.8h-4.3v3.8h4.3Zm-7-3.8v3.8h-4.3v-3.8h4.3Z",
    fill: "currentColor"
  })));
};
export default SvgSugar;